import { Text, VStack } from "@chakra-ui/react";
import Layout from "../../containers/Layout";
import VideoTemplate from "../VideoTemplate/VideoTemplate";
import Seo from "../Seo/Seo";

const mainTextContent = (
  <VStack align="start" spacing={4}>
    <Text>
      🗓️ <strong>Already a student?</strong> Just pick a date and time that
      suits you using the calendar below — I’ll confirm your booking by email.
    </Text>
    <Text>
      ✉️ <strong>New here?</strong> Subscribe to my newsletter and be the first
      to know when free lessons become available!
    </Text>
  </VStack>
);

const GetStarted = () => {
  return (
    <Layout mt={20}>
      <Seo
        title="Book a Spanish Lesson"
        description="Ready to speak Spanish? Pick a date and time that suits you and book your next lesson with Alex."
        path="/book-a-lesson"
      />
      <VideoTemplate
        imageUrl="images\calander_img1.png"
        imageAlt="Booking calendar for Spanish lessons"
        mainTitle="Ready to speak Spanish?"
        subTitle="Book a lesson and start your journey!"
        mainText={mainTextContent}
        buttonLabel="Book Now"
        linkPath="https://calendly.com/spanishwithalex"
        showButton={true}
      />
    </Layout>
  );
};

export default GetStarted;
